import Slider from "./Slider";
import Menu from "./Menu";
import Globe from "./Globe";
import InviteLink from "./InviteLink";

document.addEventListener("DOMContentLoaded", () => {
  const sliders = document.querySelectorAll(".m-slider");
  for (const slider of sliders) {
    new Slider(slider);
  }

  const inviteLinks = document.querySelectorAll(".js-invite-link");
  for (const inviteLink of inviteLinks) {
    new InviteLink(inviteLink);
  }

  const menu = document.querySelector(".m-navigation");
  if (menu) {
    new Menu(menu);
  }

  const globe = document.querySelector("#js-globe");
  if (globe) {
    new Globe(globe);
  }
});
